import { Route } from '@angular/router';
import { AppUrls } from '../../../../../../common/dto/app-urls';

export const PopupsRoute: Route = {
  path: AppUrls.Dashboard._.Announce._.Popups.relativeUrl,
  children: [
    {
      path: AppUrls.Dashboard._.Announce._.Popups._.PopupList.relativeUrl,
      loadComponent: () => import('./popup-list/popup-list.component').then(_ => _.PopupListComponent),
      pathMatch: 'full',
    },
    {
      path: AppUrls.Dashboard._.Announce._.Popups._.PopupEditor.relativeUrl,
      loadComponent: () => import('./popup-editor/popup-editor.component').then(_ => _.PopupEditorComponent),
    },
    {
      path: '**',
      redirectTo: AppUrls.Dashboard._.Announce._.Popups._.PopupList.relativeUrl,
    },
  ],
};
